import React, { useEffect } from 'react';
import { observer } from "mobx-react";
import 'react-toastify/dist/ReactToastify.css';
import { Layout } from '../components/Layout';
import store from '../components/Stores/SurveyStore';
import PrivateRoute from '../Routing/PrivateRoute'

// The SurveyElement component is used to render input questions (ie: textinput, numinput, calculated, textarea) 
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer'
import PreviousYearDataPanel from '../components/PreviousYearDataPanel';
import SubsectionPanel from '../components/SubsectionPanel'
import SurveyConditionalSegment from "../components/SurveyConditionalSegment";

// Common Pages
import GenericHomePage from '../components/GenericHomePage';

// Modals
import HelpModal from "../components/Modals/HelpModal"
import AddCommentModal from "../components/Modals/AddCommentModal"
import AddExplanationModal from "../components/Modals/AddExplanationModal"

//Grid Components 
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';

// Misc
import DeveloperWindow from "../components/DeveloperWindow"
import { Switch} from 'react-router-dom';
import { LoadPABSSurvey } from '../control';
import { CommonResponses, ElementType, NumberFormat, PlaceholderFormat, SelectCombos } from '../Enums/constants';
import { ToastContainer, Slide } from 'react-toastify';
import SurveyLoadingScreen from '../components/SurveyLoadingScreen'
import LogoutConfirmModal from '../components/Modals/LogoutConfirmModal'
import PabsLaundromatPage from '../components/Laundromat/PabsLaundromatPage';
import ErrorSummaryDetailed from '../components/ErrorSummaryDetailed';
import {getCurrencyPlaceHolder} from "../helpers";
import {PabsLgCostsTab} from "./PabsLgSurvey.CostsTab";
import {PabsLgTransactionsTab} from "./PabsLgSurvey.TransactionsTab";
import {PabsLgCommunicationTab} from "./PabsLgSurvey.CommunicationTab";
import {PabsLgCustomerExperienceTab} from "./PabsLgSurvey.CustomerExperienceTab";
import {PabsLgSubmitTab} from "./PabsLgSurvey.SubmitTab";

const Home = () => {
    return (
        <SurveyPage>
            <SurveyTitleArea />
            <SurveyContentContainer homePage={true}>
                <GenericHomePage
                    dueDate='November 16th, 2026'
                    surveyCategoryName='Pension Administration Benchmarking LG'
                    contact1={[
                        'John Simmonds',
                        'johns@explorecem.com',
                        '02038879289',
                    ]}
                />
            </SurveyContentContainer>
        </SurveyPage>
    )
}

function Start() {
    let currencyPlaceHolderBillions = getCurrencyPlaceHolder(PlaceholderFormat.CURRENCY_BILLIONS);

    return (
        <SurveyPage>
            <SurveyTitleArea pageName="Start"/>
            <SurveyContentContainer>
                <SurveySection labelText="Start">
                    <SurveyElement
                        questionNumber="1"
                        name="Longname"
                        labelText="System name"
                        placeholder="System name"
                        inputType={ElementType.TEXT}
                    />
                    <SurveyElement
                        questionNumber="2"
                        labelText="Main Survey Contact"
                    />
                    <SurveyElement
                        questionNumber="2.a"
                        name="Name"
                        labelText="Name"
                        placeholder="Name"
                        inputType={ElementType.TEXT}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="2.b"
                        name="Title"
                        labelText="Job title"
                        placeholder="Job title"
                        inputType={ElementType.TEXT}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="2.c"
                        name="Email"
                        labelText="Email"
                        placeholder="Email"
                        inputType={ElementType.TEXT}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="2.d"
                        name="Telephone"
                        labelText="Telephone"
                        placeholder="Telephone"
                        inputType={ElementType.TEXT}
                        subQuestion
                    />
                </SurveySection>
                <SurveySection
                    labelText="Plan Description">
                    <SurveyElement
                        questionNumber="3"
                        labelText="Indicate 'yes' if your employers/ member groups can be described as the following (indicate all that apply):"
                    />
                    <SurveyElement
                        questionNumber="3.a"
                        name="CityOrCountyOnly"
                        labelText="Is your membership limited to a city or county?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.b"
                        name="ParticipatingLocal"
                        labelText="Participating Local Employers? "
                        note={"[i.e. municipalities have a choice in participating in your plan]"}
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion />
                    <SurveyElement
                        questionNumber="3.c"
                        name="State"
                        labelText="State, Province, Country?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.d"
                        name="Teachers"
                        labelText="Teachers?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.e"
                        name="School"
                        labelText="School Employees (Custodians, Admin. Staff)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.f"
                        name="PoliceAndFire"
                        labelText="Safety (Police, Fire, Sheriff's Dept, etc)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.g"
                        name="OtherJudgesLegislators"
                        labelText="Other (Judges, Legislators, etc)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.h"
                        name="Corporate"
                        labelText="Corporate?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.i"
                        name="Industry"
                        labelText="Industry? (Describe)"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="3.i.i1"
                        name="IndustryDescr"
                        inputType={ElementType.TEXTAREA}
                        showIf={{Industry: { not: CommonResponses.NO }}}
                        doubleSubQuestion
                    />
                    <SurveyElement
                        questionNumber="4"
                        labelText="Which of the following descriptions best describes the non-optional benefit plans that you administer for each of your member groups:"
                        note="A plan is non-optional if members' must participate in it, or choose between it and alternatives. Do not include membership in benefit plans that are supplemental and optional such as deferred compensation 457, 403B or 401(k) plans. Do not include plans administered by a 3rd party."
                    />
                    <SurveyElement
                        questionNumber="4.a"
                        name="Q_226aYN"
                        labelText="Traditional Defined Benefit (&quot;DB&quot;)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.b"
                        name="Q_226bYN"
                        labelText="DC Cash Balance (aka Money Purchase)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.c"
                        name="Q_226dYN"
                        labelText="Hybrid DB/ DC Cash Balance?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.d"
                        name="Q_226cYN"
                        labelText="Hybrid DB/ Money Match?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.e"
                        name="DROPSavings"
                        labelText="DROP savings?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.f"
                        name="Q_226gYN"
                        labelText="Defined Contribution (&quot;DC&quot;)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.g"
                        name="HybridDbDc"
                        labelText="Hybrid DB/ DC?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.h"
                        name="Q_226iYN"
                        labelText="Other (describe)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="4.h.h1"
                        name="Q_226iDescr"
                        inputType={ElementType.TEXTAREA}
                        showIf={{"Q_226iYN": { not: CommonResponses.NO }}}
                        doubleSubQuestion
                    />
                    <SurveyElement
                        questionNumber="5"
                        labelText="Which of the following programs do you offer to members AND administer yourself?"
                        note="(i.e., design, enrolment, premium collection)"
                    />
                    <SurveyElement
                        questionNumber="5.a"
                        name="Q_216b"
                        labelText="Pre-retirement health?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.b"
                        name="Q_216c"
                        labelText="Post-retirement health?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.c"
                        name="Q_216d"
                        labelText="Pre-retirement dental and vision?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.d"
                        name="Q_216e"
                        labelText="Post-retirement dental and vision?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.e"
                        name="Q_216f"
                        labelText="Long-term care insurance?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.f"
                        name="Q_216h"
                        labelText="Loans to members?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.g"
                        name="Q_216i"
                        labelText="Optional tax deferred savings plans?"
                        note="i.e., 457, 403, 401k, 401a, etc."
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.h"
                        name="Q_216m"
                        labelText="Optional insurance?"
                        note="i.e., life and/or auto and/or home"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyElement
                        questionNumber="5.i"
                        name="Q_216n"
                        labelText="Other (describe)?"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                        subQuestion
                    />
                    <SurveyConditionalSegment
                        showIf={{ "Q_216n": { not: CommonResponses.NO } }}
                    >
                        <SurveyElement
                            questionNumber="5.i.i1"
                            name="Q_216nDescr"
                            labelText="Describe program:"
                            inputType={ElementType.TEXTAREA}
                            doubleSubQuestion
                        />
                        <SurveyElement
                            questionNumber="5.i.i2"
                            name="Q_216oDescr"
                            labelText="Describe another program (if any):"
                            inputType={ElementType.TEXTAREA}
                            doubleSubQuestion
                        />
                        <SurveyElement
                            questionNumber="5.i.i3"
                            name="Q_216pDescr"
                            labelText="Describe another program (if any):"
                            inputType={ElementType.TEXTAREA}
                            doubleSubQuestion
                        />
                    </SurveyConditionalSegment>
                    <SurveyElement
                      questionNumber="6"
                      labelText="What is the month of your fiscal year end?"
                      inputType={ElementType.SELECT}
                      name="Q_217"
                      options={["", "January", "March", "May", "June", "August", "September", "December"]}
                      note="All questions in this survey are for your most recently completed fiscal year."
                    />
                    <SurveyElement
                        questionNumber="7"
                        name="Assets"
                        labelText="What was the end of fiscal year value of your pension fund assets (in billions)?"
                        placeholder={currencyPlaceHolderBillions}
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.MONEYBILLION}
                        allowNA
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="8"
                        name="Employers"
                        labelText="Number of employers at the end of your fiscal year?"
                        placeholder="# employers"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                    />
                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    );

}

function Members() {

    const currentDataYear = store.currentSurvey?.DataYear
    const priorDataYear = currentDataYear - 1

    return (
        <SurveyPage>
            <SurveyTitleArea pageName="Members" />
            <SurveyContentContainer>
                <SurveySection labelText="Members">
                    <SurveyElement
                        questionNumber="9"
                        labelText="Provide the breakdown of total members between:"
                    />
                    <SurveyElement
                        inputType="grid"
                        styleName={"dataTable membersTable"}>
                        <SurveyGridHeader>
                            <SurveyElement
                                labelText=""
                                inputType={ElementType.LABEL}
                                name=""
                            />
                            <SurveyElement
                                labelText={`Members at end of fiscal year ${currentDataYear}`}
                                inputType={ElementType.LABEL}
                            />
                            <SurveyElement
                                labelText={`Members at end of fiscal year ${priorDataYear}`}
                                inputType={ElementType.LABEL}
                            />
                        </SurveyGridHeader>
                        <SurveyGridBody>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="9.a"
                                    labelText="Active Members"
                                    inputType={ElementType.LABEL}
                                    name=""
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="ActiveMembers"
                                    pageName="Members"
                                    placeholder="#"
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="ActiveMembersLastYear"
                                    pageName="Members"
                                    placeholder="#"
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="9.b"
                                    labelText="Inactive members"
                                    inputType={ElementType.LABEL}
                                    name=""
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="InactiveMembers"
                                    pageName="Members"
                                    placeholder="#"
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="InactiveMembersLastYear"
                                    pageName="Members"
                                    placeholder="#"
                                />
                            </SurveyGridRow>
                            <SurveyGridRow>
                                <SurveyElement
                                    questionNumber="9.c"
                                    labelText="Annuitants (Service, Disabled, Survivor)"
                                    inputType={ElementType.LABEL}
                                    name=""
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="Annuitants"
                                    pageName="Members"
                                    placeholder="#"
                                />
                                <SurveyElement
                                    inputType={ElementType.NUMBER}
                                    name="AnnuitantsLastYear"
                                    pageName="Members"
                                    placeholder="#"
                                />
                            </SurveyGridRow>
                        </SurveyGridBody>
                    </SurveyElement>
                    <SurveyElement
                        questionNumber="10"
                        labelText="What were your volumes for: "
                    />
                    <SurveyElement
                        questionNumber="10.a"
                        labelText="Service retirement inceptions?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="MembershipServiceInceptionsVol"
                        placeholder="# or unknown"
                        subQuestion
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="10.b"
                        labelText="Inceptions to survivors, partners, ex-partners or dependents? "
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="MembershipSurvivorsInceptionsVol"
                        subQuestion
                        placeholder="# or unknown"
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="10.c"
                        labelText="Disability retirement inceptions? "
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="MembershipDisabilityInceptionsVol"
                        subQuestion
                        placeholder="#, n/a or unknown"
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="10.d"
                        labelText="Disability retirement applications? "
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="Q_206b"
                        subQuestion
                        placeholder="#, n/a or unknown"
                        allowUnknown
                        allowNA
                    />
                    <SurveyElement
                        questionNumber="10.e"
                        labelText="Deaths? "
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER}
                        name="MembershipDeathVol"
                        subQuestion
                        placeholder="# or unknown"
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="10.f"
                        labelText="New active members?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="NewActivesExcludeRehires"
                        subQuestion
                        placeholder="# or unknown"
                        allowUnknown
                    />
                    <SurveyElement
                        questionNumber="10.g"
                        labelText="Active members exiting employment?"
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="ActiveToInactive"
                        subQuestion
                        placeholder="# or unknown"
                        allowUnknown
                        note="Exclude service and disability retirements"
                    />
                    <SurveyElement
                        questionNumber="10.h"
                        labelText="Withdrawals, refunds? "
                        inputType={ElementType.NUMBER}
                        format={NumberFormat.INTEGER} 
                        name="MembershipRefundsVol"
                        subQuestion
                        placeholder="# or unknown"
                        allowUnknown
                    />
                </SurveySection>
            </SurveyContentContainer>

        </SurveyPage>
    );
}

const printPage = () => {
    return (
       <ErrorSummaryDetailed/>
    );
}

export const PabsLgSurvey = observer(() => {
    useEffect(() => {
        if (store.currentSurvey == null || store.currentSurvey[0] == null) {
            LoadPABSSurvey();
        }
    }, []);

    if (store.loadingSurvey) {
        return (<SurveyLoadingScreen />);
    }
    return (
        <Layout>
            <Switch>
                <PrivateRoute exact path='/pabslg' component={Home} allowIfPageExists="Home" allowClientAccess />
                <PrivateRoute exact path='/pabslg/Home' component={Home} allowIfPageExists="Home" allowClientAccess />
                <PrivateRoute exact path='/pabslg/Start' component={Start} allowIfPageExists={store.local.start} allowClientAccess />
                <PrivateRoute exact path='/pabslg/Members' component={Members} allowIfPageExists={store.local.members} allowClientAccess />
                <PrivateRoute exact path='/pabslg/Costs' component={PabsLgCostsTab} allowIfPageExists={store.local.costs} allowClientAccess/>
                <PrivateRoute exact path='/pabslg/Transactions' component={PabsLgTransactionsTab} allowIfPageExists={store.local.transactions} allowClientAccess/>
                <PrivateRoute exact path='/pabslg/Communication' component={PabsLgCommunicationTab} allowIfPageExists={store.local.communication} allowClientAccess/>
                <PrivateRoute exact path='/pabslg/CustomerExperience' component={PabsLgCustomerExperienceTab} allowIfPageExists={store.local.customerExperience} allowClientAccess />
                <PrivateRoute exact path='/pabslg/Submit' component={PabsLgSubmitTab} allowIfPageExists="Home" />
                <PrivateRoute exact path='/pabslg/laundromat' component={PabsLaundromatPage} />
                <PrivateRoute path='*' component={Home} allowClientAccess />
            </Switch>
            
            <SubsectionPanel />
            <PreviousYearDataPanel />

            <HelpModal />
            <AddCommentModal />
            <AddExplanationModal />
            <DeveloperWindow />
            <ToastContainer transition={Slide} />
            <LogoutConfirmModal />
        </Layout>
    );
});




